/** Селектор корня баннера cookies в DOM. */
export const COOKIE_CONSENT_BANNER_SELECTOR = "[data-ix-cookie-consent-banner]";

export const COOKIE_BANNER_OFFSET_VAR = "--ix-cookie-banner-offset";
export const COOKIE_BANNER_DATA_ATTR = "ixCookieBanner";
export const COOKIE_BANNER_OFFSET_EVENT = "ix-cookie-banner-offset";

/** Дополнительный зазор между баннером и лаунчером Bitrix. */
export const COOKIE_BANNER_LAUNCHER_GAP_PX = 12;

export function isCookieBannerVisible(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.dataset[COOKIE_BANNER_DATA_ATTR] === "visible";
}

export function notifyCookieBannerOffsetChange(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(COOKIE_BANNER_OFFSET_EVENT));
}

/** Обновляет CSS-переменную смещения по фактической высоте баннера. */
export function syncCookieBannerOffset(element: HTMLElement): void {
  const height = element.getBoundingClientRect().height;
  const offset = Math.max(0, Math.ceil(height + COOKIE_BANNER_LAUNCHER_GAP_PX));

  document.documentElement.style.setProperty(
    COOKIE_BANNER_OFFSET_VAR,
    `${offset}px`,
  );
  document.documentElement.dataset[COOKIE_BANNER_DATA_ATTR] = "visible";
  notifyCookieBannerOffsetChange();
}

export function clearCookieBannerOffset(): void {
  document.documentElement.style.removeProperty(COOKIE_BANNER_OFFSET_VAR);
  delete document.documentElement.dataset[COOKIE_BANNER_DATA_ATTR];
  notifyCookieBannerOffsetChange();
}
